export * from './delete-or-cancel-dialog';
export * from './document-dialog';
export * from './remove-dialog';
export * from './save-or-discard-dialog';
export * from './dialogs.module';
